import { useMemo } from 'react'

import { usePayoutScheme } from '@pages/IntroducingBroker/Dashboard/hooks/usePayoutScheme'
import type { WidgetVisibilityContext } from '@pages/IntroducingBroker/DashboardPoC/widgetRegistry'
import { useIBRoutesConditions } from '@pages/IntroducingBroker/IntroducingBrokerRoutes'
import { useIntroducingBrokerById } from '@pages/IntroducingBroker/hooks/useIntroducingBrokerById'

import { useAccountReadContext } from '@context/AccountContextContext'

import { isTickmillPartner } from '@utils/companyName.utils'

import { useIBReferralCodes } from '@hooks/useIBReferralCodes'

export function useDashboardVisibility(): WidgetVisibilityContext {
  const { account } = useAccountReadContext()
  const { data: introducingBroker, isLoading: isIntroducingBrokerLoading } =
    useIntroducingBrokerById()
  const { ibCode, mtCode, isLoading: isReferralCodesLoading } = useIBReferralCodes()
  const { isLoading: isPayoutSchemeLoading, isPayoutSchemeVisible } = usePayoutScheme()
  const { isRebatesVisible } = useIBRoutesConditions()

  const isPartner = isTickmillPartner(account)
  const loyaltyProgramEnabled = Boolean(introducingBroker?.loyaltyProgramEnabled)
  const isVisibilityReady =
    !isIntroducingBrokerLoading && !isReferralCodesLoading && !isPayoutSchemeLoading

  return useMemo(
    () => ({
      loyaltyProgramEnabled,
      isPayoutSchemeVisible,
      isPartner,
      ibCode,
      mtCode,
      isRebatesVisible,
      isVisibilityReady,
    }),
    [
      loyaltyProgramEnabled,
      isPayoutSchemeVisible,
      isPartner,
      ibCode,
      mtCode,
      isRebatesVisible,
      isVisibilityReady,
    ]
  )
}
